import React, { Component, Fragment } from 'react';
import MyContent from '../../layout/MyContent';
import Typography from '@material-ui/core/Typography';
import Pagination from '@material-ui/lab/Pagination';
import rf from '../../requests/requests';
import createNotification from '../../common/Notifications';

import './style.scss';
import UsersTable from "./UsersTable";

class UsersList extends Component {
   constructor(props) {
    super(props);
    this.state = {
      users: [],
      pagination: {
        page: null,
        total: null,
      },
      page: 1,
      user_detail: false,
      user_id: null,
      userPrams: {},
    };

    this.getUsers = this.getUsers.bind(this);
    this.handleChangePagination = this.handleChangePagination.bind(this);
  }

  componentDidMount() {
    this.getUsers();
  }

  getUsers(params) {
    rf.get(`/admin/users`, { params: params })
      .then(res => {
        this.setState({ page: res.data.meta.pagination.page});
        this.setState(state => ({
          users: res.data.users,
          pagination: res.data.meta.pagination,
        }));
      })
      .catch(error => {
        const message = error.response && error.response.data && error.response.data.errors[0]&& error.response.data.errors[0].message;
        createNotification(message);
      });
  }

  paginationUsers() {
    const total = this.state.pagination.total;

    if(total >= 10) {
      return (
        <div style={{margin: '30px 0px', textAlign: 'center'}}>
          <Pagination className="pagination" count={Math.ceil(total / 10)} page={this.state.page} onChange={this.handleChangePagination} variant="outlined" shape="rounded" />
          <Typography style={{marginTop: '16px'}} className="page_of">{this.state.page} /  {(total / 10) < 1 ? '1' : Math.ceil(total / 10)}</Typography>
        </div>
      )
    }
  }

  handleChangePagination(event, value) {
    const params = {
      page: value
    }
    this.getUsers(params)
  };

  render() {
    return (
      <MyContent name='users' header='ユーザー一覧'>
        <Fragment>
          <UsersTable
            users={this.state.users}
            getUsers={this.getUsers}
          />
          {this.paginationUsers()}
        </Fragment>
      </MyContent>
    );
  };
}

export default UsersList;
